/**
 * Custom version of the HorizontalRule Dijit
 */

define([
    "dojo/_base/declare",// declare
    "dijit/_Widget",
    "dijit/_TemplatedMixin"
], function (declare, _Widget, _TemplatedMixin) {

// module:
// dijit/form/HorizontalRule


    return declare("dijit.form.HorizontalRule", [_Widget, _TemplatedMixin], {
        // summary:
        // Hash marks for `dijit/form/HorizontalSlider`

        templateString: '<div class="dijitRuleContainer dijitRuleContainerH"></div>',

        // count: Integer
        // Number of hash marks to generate
        count: 3,

        // container: String
        // For HorizontalSlider, this is either "topDecoration" or "bottomDecoration",
        // and indicates whether this rule goes above or below the slider.
        container: "containerNode",

        // ruleStyle: String
        // CSS style to apply to individual hash marks
        ruleStyle: "",

        _positionPrefix: '<div class="dijitRuleMark dijitRuleMarkH" style="left:',
        _positionSuffix: '%;',
        _suffix: '"></div>',

        // values where hash marks must be drawn
        ticks: null,
        minimum: 0,
        maximum: 100,

        // _isHorizontal: [protected extension] Boolean
        // VerticalRule will override this...
        _isHorizontal: true,

        //for QE purposes
        isAddQeIdForTickBased: true,
        _qeIdSuffix: 'id=',

        _genHTML: function (pos, ndx) {
            var qeId = "";
            if (this.isAddQeIdForTickBased && this.ticks) {//add id only for tick-based setting, so check if ticks are present
                qeId = '"' + this._qeIdSuffix + '"' + this["class"] + '_' + this.ticks[ndx];
            }
            return this._positionPrefix + pos + this._positionSuffix + this.ruleStyle + qeId + this._suffix;
        },

        buildRendering: function () {
            this.inherited(arguments);
            //TODO: revisit removing innerHTML
            var innerHTML = "", i, range, interval;

            if (this.ticks) { //tick-based setting
                range = this.maximum - this.minimum;
                for (i = 0; i < this.count; i += 1) {
                    innerHTML += this._genHTML(((this.ticks[i] - this.minimum) / range) * 100, i);
                }
            } else {//count-based
                innerHTML = this._genHTML(0, 0);
                interval = 100 / (this.count - 1);
                for (i = 1; i < this.count - 1; i += 1) {
                    innerHTML += this._genHTML(interval * i, i);
                }
                innerHTML += this._genHTML(100, this.count - 1);
            }

            this.domNode.innerHTML = innerHTML;
        }
    });

});